import { post, get, deleteRequest } from "./xhr/fetch";
import moment from 'moment';

export const getBannerList = (param) => {
  return get("/product/carouselImage", param);

}
export const getModules = (param) => {
  return get("/product/module", param);
}

export const gameAccountList = (param) => {
  let url = "/product/gameAccount";
  Object.keys(param).filter(key => param[key] !== undefined && param[key] !== null && param[key] !== '' && param[key].length !== 0)
    .forEach((key, index) => {
      let value = encodeURIComponent(param[key]);
      if(key === 'price.start_price' || key === 'price.end_price' || key === 'gender') {
        value = Number(param[key]);
      }
      if (index === 0) {
        url += `?${key}=${value}`;
      } else {
        url += `&${key}=${value}`;
      }
    })
  return get(url);
}
export const gameMaterialList = (param) => {
  let url = "/product/gameMaterial";
  Object.keys(param).filter(key => param[key] !== undefined && param[key] !== null && param[key] !== '' && param[key].length !== 0)
    .forEach((key, index) => {
      let value = encodeURIComponent(param[key]);
      if(key === 'price.start_price' || key === 'price.end_price' || key === 'gender') {
        value = Number(param[key]);
      }
      if (index === 0) {
        url += `?${key}=${value}`;
      } else {
        url += `&${key}=${value}`;
      }
    })
  return get(url);
}
export const getGoldList = (param) => {
  let url = "/product/gameGold";
  Object.keys(param).filter(key => param[key] !== undefined && param[key] !== null && param[key] !== '' && param[key].length !== 0)
    .forEach((key, index) => {
      let value = encodeURIComponent(param[key]);
      if(key === 'price.start_price' || key === 'price.end_price' || key === 'gender') {
        value = Number(param[key]);
      }
      if (index === 0) {
        url += `?${key}=${value}`;
      } else {
        url += `&${key}=${value}`;
      }
    })
  return get(url);
}
 
export const accountVerify = (param) => {
  return post("/product/accountVerify/check", param);
}
export const customerVerify = (param) => {
  return post("/product/customer/check", param);
}
export const getGameConfig = (param) => {
  return get("/product/gameConfig", param);
} 

export const getcustomer = (param) => {
  return get("/product/customer", param);
} 


export const gameAccountimage = (param) => {
  return get("/product/gameAccount/image", param);
} 

export const gameMaterialimage = (param) => {
  return get("/product/gameMaterial/image", param);
} 

export const gameGoldimage = (param) => {
  return get("/product/gameGold/image", param);
} 